// extracted by mini-css-extract-plugin
export default {"calloutChild":"calloutChild-OCox4","closeButton":"closeButton-gpLUG"};